module.exports = __webpack_public_path__ + "img/instagram.d0b68195.svg";